const shifts = state => state.shifts
const shift = state => state.shift

export default {
  shifts,
  shift
};
